module.exports = __webpack_public_path__ + "static/img/botchling.baa82c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/botchling.png
// module id = 0hbv
// module chunks = 0